import { gql } from '@apollo/client';

import APPOINTMENTS_FRAGMENT from '../fragments/appointments';
import DOCUMENTS_FRAGMENT from '../fragments/documents';

export const CREATE_APPOINTMENT = gql`
  ${APPOINTMENTS_FRAGMENT}
  mutation createAppointmentEntity($doc: AppointmentInput!) {
    createAppointmentEntity(doc: $doc) {
      ...AppointmentsFragment
    }
  }
`;

export const UPDATE_APPOINTMENT = gql`
  ${APPOINTMENTS_FRAGMENT}
  mutation updateAppointmentEntity($updatedDoc: AppointmentInput!, $filter: AppointmentInput!) {
    updateAppointmentEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...AppointmentsFragment
    }
  }
`;

export const DELETE_APPOINTMENT = gql`
  mutation deleteAppointmentEntity($id: String!) {
    deleteAppointmentEntity(id: $id) {
      message
    }
  }
`;

export const CREATE_MANY_APPOINTMENT = gql`
  ${APPOINTMENTS_FRAGMENT}
  mutation createManyAppointmentEntity($doc: [AppointmentInput!]!) {
    createManyAppointmentEntity(doc: $doc) {
      ...AppointmentsFragment
    }
  }
`;

export const UPDATE_MANY_APPOINTMENT = gql`
  ${APPOINTMENTS_FRAGMENT}
  mutation updateManyAppointmentEntity($updatedDoc: [AppointmentInput!]!, $filter: [AppointmentInput!]!) {
    updateManyAppointmentEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...AppointmentsFragment
    }
  }
`;

export const DELETE_MANY_APPOINTMENT = gql`
  ${APPOINTMENTS_FRAGMENT}
  mutation deleteManyAppointmentEntity($id: [String!]!) {
    deleteManyAppointmentEntity(id: $id) {
      ...AppointmentsFragment
    }
  }
`;

export const GENERATE_APPOINTMENT_SHIPPING_LABEL = gql`
  ${DOCUMENTS_FRAGMENT}
  mutation generateShippingLabel($appointmentId: String!) {
    generateShippingLabel(appointmentId: $appointmentId) {
      ...DocumentsFragment
    }
  }
`;
